import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Drawer } from '@crehana/compass.ui';
import { FeatureFlagProvider } from '@crehana/feature-flags/react';
import { useUITheme } from '@crehana/layouts';
import { useMediaQuery } from '@crehana/react-hooks';
import { isProduction } from "../constants";
import { FEATURE_FLAGS_V5_KEYS } from "./featureFlags";
import { useAdminLinks, useLearning, useMenuLinks, useTalentModules } from "./hooks";
import SidebarMenu from "./SidebarMenu";
import { jsx as _jsx } from "react/jsx-runtime";
//
var CrossPlatformNavigationComponent = function CrossPlatformNavigationComponent(_ref) {
  var email = _ref.email,
    organizationSlug = _ref.organizationSlug,
    sidebarType = _ref.sidebarType,
    handleUrl = _ref.handleUrl,
    mobileSidebarOpen = _ref.mobileSidebarOpen,
    hideMobileSidebar = _ref.hideMobileSidebar,
    productPlatform = _ref.productPlatform,
    isFromMFAdminPanel = _ref.isFromMFAdminPanel;
  var _useUITheme = useUITheme(),
    isDark = _useUITheme.isDark;
  var talentModules = useTalentModules({
    email: email,
    organizationSlug: organizationSlug
  });
  var _useLearning = useLearning({
      email: email
    }),
    _isLearningModuleActive = _useLearning.isLearningModuleActive,
    learningOrgSlug = _useLearning.learningOrgSlug,
    myRole = _useLearning.myRole,
    isB2BAllCatalog = _useLearning.isB2BAllCatalog;
  var pathname = window.location.pathname;
  var isLearningModuleActive = productPlatform === 'learning' || _isLearningModuleActive;
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var organizationSlugToUse = organizationSlug !== null && organizationSlug !== void 0 ? organizationSlug : isLearningModuleActive ? learningOrgSlug : '';
  var useAdminLinksData = useAdminLinks({
    talentAdminModules: talentModules.adminModules,
    isLearningModuleActive: isLearningModuleActive,
    organizationSlug: organizationSlugToUse,
    pathname: pathname,
    userEmail: email,
    handleUrl: handleUrl,
    productPlatform: productPlatform,
    isProduction: isProduction,
    isFromMFAdminPanel: isFromMFAdminPanel
  });
  var useMenuLinksData = useMenuLinks({
    talentModules: talentModules.collaboratorModules,
    myRole: myRole,
    isB2BAllCatalog: isB2BAllCatalog,
    organizationSlug: organizationSlugToUse,
    isLearningModuleActive: isLearningModuleActive,
    pathname: pathname,
    handleUrl: handleUrl,
    productPlatform: productPlatform,
    userEmail: email,
    isProduction: isProduction
  });
  var sidebarData = sidebarType === 'admin' ? useAdminLinksData : useMenuLinksData;
  var backToUrl = sidebarData.backToUrl,
    currentSingleRoute = sidebarData.currentSingleRoute,
    header = sidebarData.header,
    menuLinks = sidebarData.menuLinks,
    onClickItem = sidebarData.onClickItem,
    footerLinks = sidebarData.footerLinks;
  return /*#__PURE__*/_jsx("div", {
    children: isSm ? /*#__PURE__*/_jsx(SidebarMenu, {
      backToUrl: backToUrl,
      organizationSlug: organizationSlug,
      currentActive: currentSingleRoute,
      footerLinks: footerLinks,
      header: header,
      isDark: isDark,
      menuLinks: menuLinks,
      onClickItem: onClickItem,
      loadingTalentModules: !!talentModules.loading
    }) : /*#__PURE__*/_jsx(Drawer, {
      open: mobileSidebarOpen,
      onDismiss: hideMobileSidebar,
      position: "left",
      children: /*#__PURE__*/_jsx(SidebarMenu, {
        backToUrl: backToUrl,
        currentActive: currentSingleRoute,
        footerLinks: footerLinks,
        fullWidth: true,
        header: header,
        isDark: isDark,
        menuLinks: menuLinks,
        onClickItem: onClickItem,
        loadingTalentModules: !!talentModules.loading
      })
    })
  });
};
var CrossPlatformNavigation = function CrossPlatformNavigation(props) {
  var organizationId = props.organizationId;
  var featureFlagsV5 = FEATURE_FLAGS_V5_KEYS.map(function (flag) {
    return [flag, 'V5'];
  });
  return /*#__PURE__*/_jsx(FeatureFlagProvider, {
    flags: featureFlagsV5,
    organizationId: organizationId,
    children: /*#__PURE__*/_jsx(CrossPlatformNavigationComponent, _objectSpread({}, props))
  });
};
export default CrossPlatformNavigation;